export class DateHelper {

  private static monthNames = ['January', 'February',
    'March', 'April', 'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'];

  /**
   * @description Creates a date object from a string that is ISO-8601 compliant. If you pass null or undefined
   * The method will return a null value.
   *
   * @param string The string to change to a date.
   */
  static date(string: string): Date {

    if (string !== undefined && string !== null) {

      return new Date(string);
    }

    return null;
  }

  static monthName(monthNumber: number): string {

    return this.monthNames[monthNumber];
  }

  /**
   * Takes in a date, creates a new one, and adds days to it and returns
   * a new date
   *
   * https://stackoverflow.com/questions/563406/how-to-add-days-to-date
   *
   * @param startDate The date which we add the days to
   * @param days The number of days to add
   */
  static addDays(startDate: Date, days: number): Date {

    const incrementedDate = new Date(startDate.getTime());
    incrementedDate.setDate(incrementedDate.getDate() + days);

    return incrementedDate;

  }

  /**
   * Gets the difference between the two dates in an object which shows the difference in
   * ms, s, m, h, d
   * @param date1 first date
   * @param date2 now or future date
   */
  static diffBetweenDates(date1: Date, date2: Date = new Date()): { ms: number, s: number, m: number, h: number, d: number } {

    // Time difference in milliseconds
    let timeDiff = date2.getTime() - date1.getTime();
    if (timeDiff < 0) {
      timeDiff = -1 * timeDiff;
    }

    // Constants to use with modulo oeprator and division
    const msInSecond = 1000;
    const msInMinute = msInSecond * 60;
    const msInHour = msInMinute * 60;
    const msInDay = msInHour * 24;

    // We use the modulo to get the remained for the unit
    // then we have to divide by the unit in order to get
    // the absolute value not in milliseconds
    return {
      ms: timeDiff % msInSecond,
      s: Math.floor(timeDiff % msInMinute / msInSecond),
      m: Math.floor(timeDiff % msInHour / msInMinute),
      h: Math.floor(timeDiff % msInDay / msInHour),
      d: Math.floor(timeDiff / msInDay)
    };

  }

  static dateFromString(dateString: string): Date {

    if (!dateString) {
      return null;
    }

    // Remove empty spaces.
    const regExp = / /gi;
    const regExp2 = new RegExp(String.fromCharCode(160), 'gi');
    dateString = dateString.replace(regExp, '');
    dateString = dateString.replace(regExp2, '');

    /**
     * Check if the date includes /
     */
    if (dateString.includes('/')) {

    } else if (dateString.includes('-')) {

    }

  }

}
